import {
  ActionType,
  AutoTextField,
  DatePickerField,
  FormField,
  RadioGroupField,
  SelectField,
} from '../../../components/AutoForm/AutoFieldNew';
import {
  CAPITAL_ID,
  CAPITAL_RATE_ID,
  GOAL_CAPITAL_MIN,
  INCOME_ID,
  INCOME_RATE_ID,
  OBJECTIVE_CAPITAL,
  OBJECTIVE_ESTATE,
  OBJECTIVE_INCOME,
  OWNER_FAMILY,
  OWNER_FAMILY_LABEL,
  OWNER_JOINT,
  OWNER_PRIMARY,
  OWNER_SECONDARY,
  OWNER_TRUST,
  PURPOSE_OTHER,
  PURPOSE_RETIREMENT,
  RATE_DEFAULT,
} from './constants';

export const descriptionField: FormField = {
  id: 'description',
  label: 'Goal Description',
  type: ActionType.text,
  initialValue: '',
};

export const ownershipTrustRadioField: RadioGroupField = {
  id: 'ownershipRadio',
  label: 'Goal is for:',
  type: ActionType.radioGroup,
  options: [
    {
      value: OWNER_TRUST,
      label: 'Trust',
    },
  ],
};

export const ownershipRadioField: RadioGroupField = {
  id: 'ownershipRadio',
  label: 'Goal is for:',
  type: ActionType.radioGroup,
  needsValue: true,
  options: [
    {
      value: OWNER_PRIMARY,
      label: '', // populated later
    },
    {
      value: OWNER_SECONDARY,
      label: '', // populated later
    },
    {
      value: OWNER_JOINT,
      label: '', // populated later
    },
    {
      value: OWNER_FAMILY,
      label: OWNER_FAMILY_LABEL,
    },
  ],
};

export const planningObjectiveField: RadioGroupField = {
  id: 'planningObjective',
  label: 'Client wants to:',
  type: ActionType.radioGroup,
  needsValue: true,
  options: [
    {
      label: 'Generate an income',
      value: OBJECTIVE_INCOME,
    },
    {
      label: 'Build up a capital sum',
      value: OBJECTIVE_CAPITAL,
    },
    {
      label: 'Mitigate inheritance tax',
      value: OBJECTIVE_ESTATE,
    },
    {
      label: 'Tax Planning',
      value: 'taxPlanning',
    },
    {
      label: 'Protect against death, disability, loss of income',
      value: 'protection',
    },
    {
      label: 'Consolidate existing plans',
      value: 'financialPlanning',
    },
  ],
};

export const planningObjectivePurposeField: RadioGroupField = {
  id: 'planningObjectivePurpose',
  label: 'Purpose of Income/Pot is:',
  type: ActionType.radioGroup,
  needsValue: true,
  options: [
    {
      label: 'Retirement',
      value: PURPOSE_RETIREMENT,
    },
    {
      label: 'Pay down debt',
      value: 'debt',
    },
    {
      label: 'Education',
      value: 'education',
    },
    {
      label: 'Buy a property',
      value: 'property',
    },
    {
      label: 'Build up emergency fund',
      value: 'emergency',
    },
    {
      label: 'Gift to beneficiaries',
      value: 'gift',
    },
    {
      label: 'Other purpose',
      value: PURPOSE_OTHER,
    },
  ],
};

export const objectiveTypeField: SelectField = {
  id: 'objectiveType',
  label: 'Objective Type',
  type: ActionType.select,
  needsValue: true,
  options: [], // added in programmatically at run-time
};

export const targetIncomeField: AutoTextField = {
  id: INCOME_ID,
  label: 'Target Annual Income',
  type: ActionType.text,
  initialValue: GOAL_CAPITAL_MIN,
  currency: true,
  decimals: 2,
};

export const incomeRateField: AutoTextField = {
  id: INCOME_RATE_ID,
  label: 'Assumed annual drawdown rate',
  type: ActionType.text,
  initialValue: RATE_DEFAULT,
  percent: true,
};

export const targetCapitalField: AutoTextField = {
  id: CAPITAL_ID,
  label: 'Target capital',
  type: ActionType.text,
  initialValue: GOAL_CAPITAL_MIN,
  currency: true,
  decimals: 2,
};

export const capitalRateField: AutoTextField = {
  id: CAPITAL_RATE_ID,
  label: 'Assumed Real Return',
  type: ActionType.text,
  percent: true,
  initialValue: `${RATE_DEFAULT}`,
};

export const targetEndDateField: DatePickerField = {
  id: 'targetEndDate',
  label: 'Target Date',
  type: ActionType.datepicker,
  multiyear: true,
};

export const targetAgeField: AutoTextField = {
  id: 'targetAge',
  label: 'Target Age',
  type: ActionType.text,
  labelOnTop: true,
};

export const targetYearsField: AutoTextField = {
  id: 'targetYears',
  label: 'Years From Now',
  type: ActionType.text,
  labelOnTop: true,
};
